<template>
  <el-container
    class="container-list is-vertical"
    style="height: 100%; width: 100%; position: fixed;"
  >
    <top-header>
      <template slot="left">
        <el-input @keyup.enter.native="search" @input="delaySearch" style="width: 240px;" placeholder="搜尋" v-model="keyword" class="input-with-select">
          <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
        </el-input>

        <el-select v-model="filteringStatus" @change="search" placeholder="篩選狀態" style="width: 120px;margin-left: 10px;">
          <el-option label="全部" value="全部"/>
          <el-option label="錯誤紀錄" value="錯誤紀錄"/>
        </el-select>
      </template>
      <template slot="right">
        <!-- <el-button @click="$router.push({ name: 'createFaq' })" style="margin-right: 20px;">新增訊息</el-button> -->
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main v-loading="isLoading">
        <el-table :data="tableData" stripe height="calc(100% - 40px)">
          <template slot="empty">沒有資料</template>
          <el-table-column label="類型">
            <template slot-scope="scope">{{scope.row.Event}}</template>
          </el-table-column>
          <el-table-column label="訊息">
            <template slot-scope="scope">
              <font :color="scope.row.IsError ? 'red' : ''">{{scope.row.Message}}</font>
            </template>
          </el-table-column>
          <!-- <el-table-column label="解決者">
            <template slot-scope="scope">{{scope.row.ResolvedBy}}</template>
          </el-table-column> -->
          <el-table-column label="時間" width="170px">
            <template slot-scope="scope">{{scope.row.CreatedAt | moment}}</template>
          </el-table-column>
          <el-table-column label="解決時間" width="170px">
            <template slot-scope="scope">{{scope.row.ResolvedAt | moment}}</template>
          </el-table-column>
          <el-table-column label="操作" width="150px">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.IsError && !scope.row.ResolvedAt"
                size="mini"
                circle
                @click="resolve">
                解決
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          background
          layout="prev, pager, next"
          :currentPage="currentPage"
          :page-size="20"
          :total="searchedObjs.length"
          @current-change="onChangePage"
        ></el-pagination>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
// svgs
import '@/assets/svgs/index.js'
// mixin
import MixinFilters from '@/utils/filters/filter-mixin.vue'
import MixinDelaySearch from '@/utils/mixin-delaysearch.vue' // filterObjs method required
export default {
  mixins: [MixinFilters, MixinDelaySearch],
  components: {
    LeftMenu,
    TopHeader
  },
  data () {
    return {
      tableData: [],
      currentPage: 1,
      isLoading: false,
      // 篩選
      filteringStatus: null,
      filteringDateRange: null
    }
  },
  computed: {},
  methods: {
    onChangePage (page) {
      this.currentPage = page
      this.tableData = this.searchedObjs.slice((page - 1) * 20, page * 20)
    },
    filterObjs () {
      if (!this.keyword && !this.filteringStatus && !this.filteringDateRange) {
        this.searchedObjs = this.$store.state.systemLog.list
        return
      }

      const isObjFitKeyword = o => {
        if (!this.keyword) return true
        if (o.Event && o.Event.includes(this.keyword)) return true
        if (o.Message && o.Message.includes(this.keyword)) return true
        return false
      }

      const isObjFitStatus = o => {
        if (!this.filteringStatus) return true
        if (this.filteringStatus === '全部') return true
        return o.IsError === (this.filteringStatus === '錯誤紀錄')
      }

      this.searchedObjs = this.$store.state.systemLog.list.filter(u => {
        return isObjFitKeyword(u) && isObjFitStatus(u)
      })
    },
    resolve () {
      alert('todo')
    }
  },
  created () {
    const initTableData = () => {
      this.searchedObjs = this.$store.state.systemLog.list
      this.tableData = this.searchedObjs.slice(0, 20)
    }
    // query...
    this.$services.systemLog.getAll(this).then(res => {
      this.$store.state.systemLog.list = res.data.result
      initTableData()
    }).catch(this.$handleServiceError)
  }
}
</script>
